<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_036"><img alt="Image" src="images/f0020-01.jpg"/></a></p><a id="file_036">
<p class="caption">The remains of the XF3F-1 rest in Pinelawn Cemetery on March 22, 1935, after the plane came apart in a dive experiment over Long Island. Grumman test pilot “Jimmy” Collins was killed in the crash. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_036.vue?f66518ba